import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$')({
  component: NotFoundPage
})

function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <p>Página não encontrada</p>
    </main>
  )
}
